import type { PopOverProps } from '@xing-com/pop-over';

import { Styled } from './styles';

export type FlagPopOverProps = {
  onCloseClick?: (e: React.MouseEvent) => void;
  premiumTheme: boolean;
};

export const FlagPopOver: React.FC<FlagPopOverProps & PopOverProps> = ({
  onCloseClick,
  children,
  premiumTheme,
  onOutsideClick,
  triggerRef,
  show,
  isInFlow,
}) => {
  return (
    <Styled.PopOver
      onOutsideClick={onOutsideClick}
      triggerRef={triggerRef}
      show={show}
      isInFlow={isInFlow}
      $premiumTheme={premiumTheme}
    >
      <Styled.PopOverContentContainer
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
      >
        <Styled.CloseButton onClick={onCloseClick} />
        <Styled.PopOverContent data-testid="user-flag-content">
          {children}
        </Styled.PopOverContent>
      </Styled.PopOverContentContainer>
    </Styled.PopOver>
  );
};
